import { Input } from 'src/components/Input';
import { SkillCard } from './SkillCard';
import { SelectBox } from 'src/components/SelectBox';
import { Label } from 'src/components/Label';

enum GateKeeperBehavior {
  REQUEST_TRANSFER = 'request_transfer',
  REQUEST_MESSAGE = 'request_message',
  REQUEST_CALLBACK = 'request_callback',
  END_CONVERSATION = 'end_conversation',
}

type GateKeeperHandlingConfig = {
  purpose: string;
  behavior: GateKeeperBehavior;
};

const behaviorLabels = {
  [GateKeeperBehavior.REQUEST_TRANSFER]: 'Request transfer to someone else',
  [GateKeeperBehavior.REQUEST_MESSAGE]: 'Leave a message',
  [GateKeeperBehavior.REQUEST_CALLBACK]: 'Call back later',
  [GateKeeperBehavior.END_CONVERSATION]: 'End the call',
};

export const validateGateKeeperHandlingConfig = (
  config: GateKeeperHandlingConfig,
): boolean => {
  if (!config || !config.purpose) {
    return false;
  }
  return !!config.purpose.trim() && !!config.behavior;
};

export function GateKeeperHandlingSkill({
  config,
  onConfigChange,
}: {
  config: GateKeeperHandlingConfig;
  onConfigChange?: (config: GateKeeperHandlingConfig) => void;
}) {
  const behaviors = Object.values(GateKeeperBehavior).map((behavior) => ({
    value: behavior,
    label: behaviorLabels[behavior],
  }));
  return (
    <SkillCard description="Choose what to share if presented with a call screen, and what should happen if the right person isn’t available.">
      <div className="mb-4">
        <Input
          label="Reason for the call"
          placeholder="Reason to be shared with the call screen"
          value={config.purpose}
          onChange={(e) =>
            onConfigChange?.({ ...config, purpose: e.target.value })
          }
          required
        />
      </div>
      <div className="mb-4">
        <Label required>What to do if the right person isn't available?</Label>
        <SelectBox
          options={behaviors}
          value={behaviors.find((b) => b.value === config.behavior)}
          onChange={(value) =>
            onConfigChange?.({
              ...config,
              behavior: value as GateKeeperBehavior,
            })
          }
        />
      </div>
    </SkillCard>
  );
}
